import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AlertDialogComponent } from 'src/app/alert-dialog/alert-dialog.component';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { DoublingEditorComponent } from '../../non-plc/costsavings/doubling-editor.component';

let countryCode;
@Component({
  selector: 'app-edit-eq-bk-calc-popup',
  templateUrl: './edit-eq-bk-calc-popup.component.html',
  styleUrls: ['./edit-eq-bk-calc-popup.component.css']
})
export class EditEqBkCalcPopupComponent implements OnInit {

  domLayout: any;
  public columnDefs: any;
  public rowData: any;
  public defaultColDef: any;
  public showGrid = false;
  public gridApi: any;
  public gridColumnApi: any;
  gridRowData: any[];
  public modifiedRowsData = [];
  sendDataToEQ: { MEKOverhead: any; MEKLabour: any; MEKMEKTotal: any; SimulationData: any; };
  sendData: any[];
  frameworkComponents: { DoublingEditor: any; };

  constructor(
    public dialogRef: MatDialogRef<EditEqBkCalcPopupComponent>,
    public dialog: MatDialog,
    private router: Router,
    private localStorageService: LocalStorageService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  public refLabour = this.data.RefLabour;
  public refOverhead = this.data.RefOverhead;
  public overhead = this.data.Overhead;
  public labour = this.data.Labour;
  public mek = this.data.MEK;
  public title = this.data.Title;
  public scenarioType = this.data.Scenariotype;
  public typeOfCost = this.data.TypeOfCost;
  public assemblyData = this.data.AssemblyData;
  public configurationid = this.data.ConfigurationId;
  public simulationData = this.data.SimulationData;
  public userId = this.data.UserId;
  public hasMinorAccess = this.data.HasMinorAccess;
  public accessibleAssemblies = this.data.AccessibleAssemblies;
  public assemblyAccessMap = this.data.AssemblyAccessMap;

  ngOnInit(): void {
    countryCode = this.localStorageService.get('countryCode');
    this.formatGridData();

    this.loadGrid();
  }

  loadGrid() {
    this.frameworkComponents = {
      DoublingEditor: DoublingEditorComponent,
    };
    this.columnDefs = [
      {
        headerName: 'Cost Type',
        field: 'CostType',
        tooltipField: 'CostType',
        headerTooltip: 'CostType',
        editable: false,
        hide: false,
        cellClass: params => (params.data.CostType === "Total" || params.data.CostType === "Assembly group" || (params?.data.IsActive === false)) ? 'colorTotal' : '',
        cellStyle: params => {
          if (params.data.CostType === "Total" || params.data.CostType === "Overhead" || params.data.CostType === "Labour" || params.data.CostType === "Assembly group") {
            return { fontWeight: 'bold' }
          }
          return null;
        }
      },
      {
        headerName: 'Reference',
        field: 'Reference',
        tooltipField: 'Reference',
        headerTooltip: 'Reference',
        editable: false,
        hide: false,
        cellClass: params => (params.data.CostType === "Total" || params.data.CostType === "Assembly group" || (params?.data.IsActive === false)) ? 'colorTotal' : '',
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        cellEditor: 'DoublingEditor',
        valueFormatter: (params) => {
          const value = parseFloat(params.value);
          return isNaN(value) || value === 0 ? null : value;
        },
        valueGetter: (params) => {
          if (params) {
            if (params.data.CostType === "Total") {
              let totalVal = 0;
              params.api.forEachNode(node => {
                if (node.data.CostType === "Labour" || node.data.CostType === "Overhead" || node.data.CostType === "Assembly group") {
                  totalVal += Number(node.data.Reference) ?? 0;
                }
              })
              // params.data.Reference = totalVal;
              return totalVal;
            }
            if (params.data.CostType === "Assembly group") {
              let totalVal = 0;
              params.api.forEachNode(node => {
                if (node.data.CostType !== "Labour" && node.data.CostType !== "Overhead" && node.data.CostType !== "Assembly group" && node.data.CostType !== "Total") {
                  if (node.data.IsActive !== false) {
                    totalVal += Number(node.data.Reference) ?? 0;
                  }
                }
              })
              // params.data.Reference = totalVal;
              return totalVal;
            }
            return params.data.Reference;
          }
        }
      },
      {
        headerName: 'Target, abs',
        field: 'TargetAbs',
        tooltipField: 'TargetAbs',
        headerTooltip: 'Target, abs',
        editable: (params) => {
          // Only editable if minor access and assembly has readwrite access
          if (this.hasMinorAccess && this.data.AssemblyAccessMap) {
            return this.assemblyAccessMap[params.data.CostType] === 'readwrite';
          }
          return params?.data?.CostType !== "Total" && params?.data?.CostType !== "Assembly group" && params?.data.IsActive !== false;
        }
        ,
        hide: false,
        cellClass: params => (params.data.CostType === "Total" || params.data.CostType === "Assembly group" || (params?.data.IsActive === false)) ? 'colorTotal' : '',
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        // cellEditor: 'DoublingEditor',
        // valueFormatter: (params) => {
        //   const value = parseFloat(params.value);
        //   return isNaN(value) || value === 0 ? 0 : value.toFixed(2);
        // },
        valueGetter: (params) => {
          if (params) {
            if (isNaN(params.data.TargetAbs)) {
              params.data.TargetAbs = 0;
            }
            if (params.data.CostType === "Total") {
              let totalVal = 0;
              params.api.forEachNode(node => {
                if (node.data.CostType === "Labour" || node.data.CostType === "Overhead" || node.data.CostType === "Assembly group") {
                  totalVal += Number(node.data.TargetAbs) ?? 0;
                }
              })
              params.data.TargetAbs = totalVal;
              return totalVal;
            }
            if (params.data.CostType === "Assembly group") {
              let totalVal = 0;
              params.api.forEachNode(node => {
                if (node.data.CostType !== "Labour" && node.data.CostType !== "Overhead" && node.data.CostType !== "Assembly group" && node.data.CostType !== "Total") {
                  if (node.data.IsActive !== false) {
                    totalVal += Number(node.data.TargetAbs) ?? 0;
                  }
                }
              })
              params.data.TargetAbs = totalVal;
              return totalVal;
            }
            return params.data.TargetAbs;
          }
        }
      },
      {
        headerName: 'Target, change in %',
        field: 'TargetChangePercent',
        tooltipField: 'TargetChangePercent',
        headerTooltip: 'Target, change in %',
        editable: (params) => {
          // Only editable if minor access and assembly has readwrite access
          if (this.hasMinorAccess && this.assemblyAccessMap) {
            return this.assemblyAccessMap[params.data.CostType] === 'readwrite';
          }
          return params?.data?.CostType !== "Total" && params?.data?.CostType !== "Assembly group" && params?.data.IsActive !== false;
        },
        hide: false,
        cellClass: params => (params.data.CostType === "Total" || params.data.CostType === "Assembly group" || (params?.data.IsActive === false)) ? 'colorTotal' : '',
        cellRenderer: CurrencyCellRenderer,
        tooltipValueGetter: CurrencyCellRenderer,
        // cellEditor: 'DoublingEditor',
        valueFormatter: (params) => {
          const value = parseFloat(params.value);
          return isNaN(value) || value === null ? '0%' : `${new Intl.NumberFormat(countryCode).format(Number(parseFloat(params.value).toFixed(2)))}%`;
        },
        // valueGetter: params => {
        //   if(params){
        //     return (Number(params.data.Target) - Number(params.data.Reference)/ Number(params.data.Target)) * 100;
        //   }
        // }
      }
    ]
    this.domLayout = 'autoHeight';
    this.showGrid = true;
    // this.rowData = [
    //   { CostType: 'Total', Reference: 50, TargetAbs: 0, TargetChangePercent: 0 },
    //   { CostType: 'Overhead', Reference: 987, TargetAbs: 0, TargetChangePercent: 0 },
    //   { CostType: 'Labour', Reference: 50, TargetAbs: 0, TargetChangePercent: 0 },
    //   { CostType: 'Assembly group', Reference: 50, TargetAbs: 0, TargetChangePercent: 0 },
    // ];
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    this.gridApi.forEachNode(node => {
      if (node.data.CostType === "Assembly group") {
        let totalAssemblyRefVal = 0;
        let totalAssemblyTarVal = 0;
        this.gridApi.forEachNode(node => {
          if (!["Overhead", "Labour", "Total", "Assembly group"].includes(node.data.CostType)) {
            if (node.data.IsActive !== false) {
              totalAssemblyRefVal += Number(node.data.Reference);
              totalAssemblyTarVal += Number(node.data.TargetAbs);
            }
          }
        })
        node.data.Reference = Number(totalAssemblyRefVal);
        node.data.TargetAbs = Number(totalAssemblyTarVal);
        node.data.TargetChangePercent = Number((((totalAssemblyTarVal - totalAssemblyRefVal) / totalAssemblyTarVal) * 100).toFixed(2));
      }
    })

    this.gridApi.forEachNode(node => {
      if (node.data.CostType === "Total") {
        let totalRefVal = 0;
        let totalTarVal = 0;
        this.gridApi.forEachNode(node => {
          if (["Overhead", "Labour", "Assembly group"].includes(node.data.CostType)) {
            totalRefVal += Number(node.data.Reference) ?? 0;
            totalTarVal += Number(node.data.TargetAbs) ?? 0;
          }
        })
        node.data.Reference = totalRefVal ?? 0;
        node.data.TargetAbs = totalTarVal ?? 0;
        node.data.TargetChangePercent = Number((((totalTarVal - totalRefVal) / totalTarVal) * 100).toFixed(2));
      }
    })
    this.gridApi.refreshCells({ force: true });
  }

  onGridSizeChanged(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }
  openAlertDialog(error) {
    this.dialog.open(AlertDialogComponent, { data: error })
  }
  onCellValueChanged(event: any) {
    const colId = event.column.getColId();
    const data = event.data;
    const reference = parseFloat(data.Reference);

    if (!["Total", "Overhead", "Labour", "Assembly group"].includes(data.CostType)) {
      event.data.IsNewAndUnconfirmed = false;
    }

    if (colId === 'TargetAbs') {
      const targetAbs = parseFloat(data.TargetAbs);
      if (!isNaN(reference) && !isNaN(targetAbs) && targetAbs !== 0) {
        data.TargetChangePercent = ((targetAbs - reference) / targetAbs) * 100;
      } else {
        data.TargetChangePercent = null;
      }
    }

    if (colId === 'TargetChangePercent') {
      const targetChangePercent = parseFloat(data.TargetChangePercent);
      if (!isNaN(reference) && !isNaN(targetChangePercent)) {
        data.TargetAbs = reference * (1 + targetChangePercent / 100);
      } else {
        data.TargetAbs = null;
      }
    }

    // 💡 Recalculate Total for Reference , Target,Abs, and Percentage 
    const allRows = [];
    event.api.forEachNode((node: any) => allRows.push(node.data));

    const totalRow = allRows.find(row => row.CostType === 'Total');
    const sumAbs = allRows
      .filter(row => row.CostType === 'Overhead' || row.CostType === 'Labour' || row.CostType === 'Assembly group')
      .reduce((sum, row) => sum + (parseFloat(row.TargetAbs) || 0), 0);
    const sumRef = allRows
      .filter(row => row.CostType === 'Overhead' || row.CostType === 'Labour' || row.CostType === 'Assembly group')
      .reduce((sum, row) => sum + (parseFloat(row.Reference) || 0), 0);

    if (totalRow) {
      totalRow.TargetAbs = sumAbs;
      totalRow.Reference = sumRef;
      // totalRow.TargetChangePercent = sumAbs === 0 ? 0 : ((sumAbs - sumRef) / sumAbs) * 100;
      totalRow.TargetChangePercent = (sumAbs && !isNaN(sumAbs) && sumAbs !== 0)
        ? ((sumAbs - sumRef) / sumAbs) * 100
        : 0;
    }

    const totalAssemblyRow = allRows.find(row => row.CostType === 'Assembly group');
    const sumAssemblyAbs = allRows
      .filter(row => row.CostType !== 'Total' && row.CostType !== 'Overhead' && row.CostType !== 'Labour' && row.CostType !== 'Assembly group')
      .reduce((sum, row) => sum + (parseFloat(row.TargetAbs) || 0), 0);
    const sumAssemblyRef = allRows
      .filter(row => row.CostType !== 'Total' && row.CostType !== 'Overhead' && row.CostType !== 'Labour' && row.CostType !== 'Assembly group')
      .reduce((sum, row) => sum + (parseFloat(row.Reference) || 0), 0);

    if (totalAssemblyRow) {
      totalAssemblyRow.TargetAbs = sumAssemblyAbs;
      totalAssemblyRow.Reference = sumAssemblyRef;
      // totalAssemblyRow.TargetChangePercent = sumAssemblyAbs === 0 ? 0 : ((sumAssemblyAbs - sumAssemblyRef) / sumAssemblyAbs) * 100;
      totalAssemblyRow.TargetChangePercent = (sumAssemblyAbs && !isNaN(sumAssemblyAbs) && sumAssemblyAbs !== 0)
        ? ((sumAssemblyAbs - sumAssemblyRef) / sumAssemblyAbs) * 100
        : 0;
    }

    event.api.refreshCells({ force: true });
  }

  formatGridData() {
    // Fallback function to handle null/undefined/"" as 0
    const safeValue = (val: any) => (val === null || val === undefined || val === '' ? null : val);

    if (this.simulationData.length == 0 || this.simulationData === undefined || this.simulationData === null) {
      // static data
      this.rowData = [
        { ReferenceId: 0, TargetId: 0, ConfigurationId: this.configurationid, CostType: 'Total', Reference: 0, TargetAbs: 0, TargetChangePercent: 0, IsActive: true },
        { ReferenceId: 0, TargetId: 0, ConfigurationId: this.configurationid, CostType: 'Overhead', Reference: safeValue(this.refOverhead), TargetAbs: safeValue(this.overhead), TargetChangePercent: 0, IsActive: true },
        { ReferenceId: 0, TargetId: 0, ConfigurationId: this.configurationid, CostType: 'Labour', Reference: safeValue(this.refLabour), TargetAbs: safeValue(this.labour), TargetChangePercent: 0, IsActive: true },
        { ReferenceId: 0, TargetId: 0, ConfigurationId: this.configurationid, CostType: 'Assembly group', Reference: 0, TargetAbs: safeValue(this.mek), TargetChangePercent: 0, IsActive: true }
      ];

      // Append dynamic assembly data
      if (Array.isArray(this.assemblyData)) {
        const dynamicRows = this.assemblyData.map(item => ({
          ReferenceId: 0,
          TargetId: 0,
          ConfigurationId: this.configurationid,
          CostType: item.Assembly || '',
          Reference: safeValue(item.TotalMEKPerSystem),
          TargetAbs: safeValue(item.TargetTotalMEKPerSystem),
          TargetChangePercent:
            item.TargetTotalMEKPerSystem === 0
              ? 0
              : ((item.TargetTotalMEKPerSystem - safeValue(item.TotalMEKPerSystem)) / item.TargetTotalMEKPerSystem) * 100,
          IsActive: true,
          IsNewAndUnconfirmed: true,
        }));

        // this.rowData = [...this.rowData, ...dynamicRows];

        // Sort assemblies alphabetically by CostType
        dynamicRows.sort((a, b) => a.CostType.localeCompare(b.CostType));

        this.rowData = [...this.rowData, ...dynamicRows];
      }
    }
    else {
      // Group simulation data by CostType (Name)
      const grouped: { [costType: string]: any } = {};
      this.simulationData.forEach(item => {
        const key = item.Name;
        if (!grouped[key]) {
          grouped[key] = {
            ReferenceId: 0,
            TargetId: 0,
            ConfigurationId: item.ConfigurationId,
            CostType: key,
            Reference: 0,
            TargetAbs: 0,
            TargetChangePercent: 0,
            IsActive: item.IsActive,
            IsNewAndUnconfirmed: (item.ScenarioType === "Reference")
              ? (item.IsNewAndUnconfirmed !== undefined ? item.IsNewAndUnconfirmed : false)
              : (item.IsNewAndUnconfirmed !== undefined ? item.IsNewAndUnconfirmed : true)
          };
        }
        if (item.ScenarioType === "Reference") {
          grouped[key].Reference = safeValue(item.CostValue);
          grouped[key].ReferenceId = safeValue(item.Id);
          if (item.IsNewAndUnconfirmed !== undefined) {
            grouped[key].IsNewAndUnconfirmed = item.IsNewAndUnconfirmed;
          }
        }
        if (item.ScenarioType !== "Reference") {
          grouped[key].TargetAbs = safeValue(item.CostValue);
          grouped[key].TargetChangePercent = safeValue(item.PercentageChange);
          grouped[key].TargetId = safeValue(item.Id);
        }
        if (item.IsNewAndUnconfirmed === undefined) {
          grouped[key].IsNewAndUnconfirmed = true;
        }
      });

      // For each assembly in assemblyData, if TargetAbs is 0 and it's not a main row, fill from assemblyData
      (this.assemblyData || []).forEach(item => {
        const key = item.Assembly || '';
        // Only for assemblies, not for main rows
        if (
          !["Total", "Overhead", "Labour", "Assembly group"].includes(key) &&
          grouped[key] &&
          (!grouped[key].TargetAbs || grouped[key].TargetAbs === 0)
        ) {
          grouped[key].TargetAbs = safeValue(item.TargetTotalMEKPerSystem);
          grouped[key].TargetChangePercent =
            grouped[key].Reference && grouped[key].TargetAbs
              ? ((grouped[key].TargetAbs - grouped[key].Reference) / grouped[key].TargetAbs) * 100
              : 0;
        }
      });

      // console.log(grouped)
      this.rowData = Object.values(grouped);
      // console.log("Formatted rowData:", this.rowData);

      // Custom order for CostType
      const order = ["Total", "Overhead", "Labour", "Assembly group"];
      const mainRows = [];
      const assemblyRows = [];

      this.rowData.forEach(row => {
        if (order.includes(row.CostType)) {
          mainRows[order.indexOf(row.CostType)] = row;
        } else {
          assemblyRows.push(row);
        }
      });

      // Sort assemblies alphabetically by CostType
      assemblyRows.sort((a, b) => a.CostType.localeCompare(b.CostType));

      // Combine main rows and sorted assemblies
      this.rowData = mainRows.filter(Boolean).concat(assemblyRows);
    }
    // Filter rowData for minor access: only show accessible assemblies, hide Labour
    if (this.hasMinorAccess && Array.isArray(this.accessibleAssemblies)) {
      this.rowData = this.rowData.filter(row =>
        row.CostType !== 'Labour' &&
        (
          ["Total", "Overhead", "Assembly group"].includes(row.CostType) ||
          this.accessibleAssemblies.includes(row.CostType)
        )
      );

      if (Array.isArray(this.rowData)) {
        this.rowData.forEach(row => {
          if (row.CostType === "Overhead" && row.Reference !== undefined) {
            row.Reference = this.refOverhead;
          }
        });
      }
    }
    console.log("Final rowData after access filtering:", this.rowData);
    console.log(this.hasMinorAccess);
    console.log(this.accessibleAssemblies);
    // else {
    //   // For non-minor access, just hide Labour
    //   this.rowData = this.rowData.filter(row => row.CostType !== 'Labour');
    // }
  }

  onSubmit(event) {
    let OverheadToSend, LabourToSend, thereinMEKToSend;
    this.gridApi.forEachNode(node => {
      if (node.data.CostType === "Overhead") {
        OverheadToSend = Number(node.data.TargetAbs);
      }
      if (node.data.CostType === "Labour") {
        LabourToSend = Number(node.data.TargetAbs);
      }
      if (node.data.CostType === "Assembly group") {
        thereinMEKToSend = Number(node.data.TargetAbs);
      }
    })
    this.getDataToSend();
    // OverheadToSend = this.gridApi.getDisplayedRowAtIndex(1).data.TargetAbs;
    // LabourToSend = this.gridApi.getDisplayedRowAtIndex(2).data.TargetAbs;
    // thereinMEKToSend = this.gridApi.getDisplayedRowAtIndex(3).data.TargetAbs;

    this.sendDataToEQ = {
      MEKOverhead: OverheadToSend,
      MEKLabour: LabourToSend,
      MEKMEKTotal: thereinMEKToSend,
      SimulationData: this.simulationData,
    };
    this.dialogRef.close(this.sendDataToEQ);
  }

  getDataToSend() {
    const dbRows: any[] = [];
    this.gridApi.forEachNode(node => {
      const row = node.data;
      // Reference row
      dbRows.push({
        //check the nullable check
        Id: row.ReferenceId || 0, // Use ReferenceId
        ConfigurationId: row.ConfigurationId,
        Name: row.CostType,
        TypeOfCost: 'Actuals', // Fill if needed
        ScenarioType: 'Reference',
        CostValue: Number(row.Reference).toFixed(0),
        PercentageChange: 0,
        IsActive: row.IsActive,
        UserId: this.userId, // Add UserId if needed
        // IsNewAndUnconfirmed: row.IsNewAndUnconfirmed,
      });
      // Target row
      dbRows.push({
        //check the nullable check
        Id: row.TargetId || 0, // Use TargetId
        ConfigurationId: row.ConfigurationId,
        Name: row.CostType,
        TypeOfCost: this.typeOfCost, // Fill if needed
        ScenarioType: this.scenarioType,
        CostValue: Number(row.TargetAbs).toFixed(0),
        PercentageChange: Number(row.TargetChangePercent).toFixed(2),
        IsActive: row.IsActive,
        UserId: this.userId, // Add UserId if needed
        IsNewAndUnconfirmed: row.IsNewAndUnconfirmed,

      });
    });
    // // Exclude rows where Id is 0 or null AND IsActive is false
    // dbRows = dbRows.filter(row =>
    //   !((row.Id === 0 || row.Id === null) && row.IsActive === false)
    // );
    // console.log("Data to send to EQ:", dbRows);
    this.simulationData = dbRows; // Update simulationData with the new data
    // // Exclude rows where Id is 0 or null AND IsActive is false
    // this.simulationData = this.simulationData.filter(row =>
    //   !((row.Id === 0 || row.Id === null) && row.IsActive === false)
    // );
    // return this.simulationData;
  }
}
// used to format the cell in germman currency format;
function CurrencyCellRenderer(params: any) {
  return params.value == undefined || params.value == null || isNaN(params.value) ? null : `${new Intl.NumberFormat(countryCode).format(Number(parseFloat(params.value).toFixed(2)))}%`;
}
function CurrencyCellRendererReadOnly(params: any) {
  return params.value == undefined ? null : new Intl.NumberFormat(countryCode).format(Number(parseFloat(params.value).toFixed(0)));
}
